import { render, staticRenderFns } from "./Traveldatefromto.vue?vue&type=template&id=efce01c2&scoped=true&"
import script from "./Traveldatefromto.vue?vue&type=script&lang=js&"
export * from "./Traveldatefromto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efce01c2",
  null
  
)

export default component.exports